import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type ScrollContainerSlice = {
  offsetTop: number
  scrollbarVisible: boolean
}

const initialState: ScrollContainerSlice = {
  offsetTop: 0,
  scrollbarVisible: false
}

const slice = createSlice({
  name: 'scrollContainer',
  initialState: initialState,
  reducers: {
    setOffsetTop: (state, action: PayloadAction<number>) => {
      state.offsetTop = action.payload
    },
    setScrollbarVisibility: (state, action: PayloadAction<boolean>) => {
      state.scrollbarVisible = action.payload
    }
  }
})

export const reducer = slice.reducer
export const actions = slice.actions
